import Button from "@common/controls/Button/component";
import { Video } from "@common/controls/Video";
import { type VideoBase } from "@common/controls/Video/component";
import { useI18n } from "@common/hooks/i18n";
import { useVisibleModal } from "@common/lib/hooks";
import { afterSuccess } from "@common/lib/misc";
import * as React from "react";
import { BecomeAffiliateModal, type BecomeAffiliateModalProps } from "./BecomeAffiliateModal";

type VideoSettings = VideoBase & {
  thumbnailUrl?: string;
  source?: string;
};

type WelcomeProps = {
  description?: string;
  title?: string;
  videoSettings: VideoSettings;
  modal: Omit<BecomeAffiliateModalProps, "isVisible" | "onClose">;
  onSubmit?: () => void;
};

export const Welcome = (props: WelcomeProps) => {
  const i18n = useI18n();

  const [visibleModal, setVisibleModal, hideVisibleModal] = useVisibleModal<"becomeAffiliate">();

  return (
    <div className="affiliate_welcome">
      <div className="description">
        <h2>{props.title}</h2>
        <div className="text_container">
          <span className="text">{props.description}</span>
        </div>
      </div>

      {props.videoSettings.source && (
        <div className="video_block">
          <Video
            {...props.videoSettings}
            url={props.videoSettings.source}
            posterUrl={props.videoSettings.thumbnailUrl}
            aspectRatio="16:9"
          />
        </div>
      )}

      <Button type="primary" onClick={props.onSubmit ? props.onSubmit : () => setVisibleModal("becomeAffiliate")}>
        {i18n.becomeAnAffiliate}
      </Button>

      <BecomeAffiliateModal
        {...props.modal}
        isVisible={visibleModal === "becomeAffiliate"}
        onClose={hideVisibleModal}
        onSubmit={afterSuccess(props.modal.onSubmit, hideVisibleModal)}
      />
    </div>
  );
};
